"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iOS = void 0;
// Detect device type
function iOS() {
    return /iPad|iPhone|iPod/.test(navigator.platform)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
exports.iOS = iOS;
